import { render, staticRenderFns } from "./DiscoverBody.vue?vue&type=template&id=07ed8ab0&scoped=true"
import script from "./DiscoverBody.vue?vue&type=script&lang=js"
export * from "./DiscoverBody.vue?vue&type=script&lang=js"
import style0 from "./DiscoverBody.vue?vue&type=style&index=0&id=07ed8ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ed8ab0",
  null
  
)

export default component.exports